
<template>
  <div id="app">
    <!-- <img src="./assets/logo.png">
    <div>
      <p>
        If Element is successfully added to this project, you'll see an
        <code v-text="'<el-button>'"></code>
        below
      </p>
      <el-button>el-button</el-button>
    </div>
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view />
    <div class="Liability">
      <div class="LiabilityC">*该页上的信息有可能改变，恕不提前通知。请联系相关零售商获取最新信息。</div>
      
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.Liability{
    font-size: 12px;
    line-height: 15px;
    background-color: #fff;
  }
.Liability .LiabilityC{
  padding: 20px 20px 5px 20px;
  max-width: 1440px;
  margin:0 auto;
}
</style>
